// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pac-container{width:100%!important;max-width:34.6875rem;margin-top:calc(var(--frm-text-input-border-spacing) + 1px);border-top:0}.pac-item{padding:2px 5px}", ""]);
// Exports
module.exports = exports;
